// The exactly-15 operators the process-jobs ruleEngine supports, with display labels and value arity.
// This is the single seam that keeps the UI value control and the emitted Condition JSON in sync:
// `valueKind` decides whether a condition carries no value, an array value, or a scalar value, and
// the same function drives both the editor control and the operator-switch normalization in serde.js.
//
// Source of truth: process-jobs/src/services/ruleEngine.ts (the `Operator` union + matchCondition).

export const OPERATORS = [
	{ value: 'equals', label: 'equals' },
	{ value: 'not_equals', label: 'not equals' },
	{ value: 'contains', label: 'contains' },
	{ value: 'not_contains', label: 'not contains' },
	{ value: 'starts_with', label: 'starts with' },
	{ value: 'ends_with', label: 'ends with' },
	{ value: 'in', label: 'in' },
	{ value: 'not_in', label: 'not in' },
	{ value: 'is_null', label: 'is empty' },
	{ value: 'is_not_null', label: 'is not empty' },
	{ value: 'regex', label: 'matches' },
	{ value: 'gt', label: '>' },
	{ value: 'lt', label: '<' },
	{ value: 'gte', label: '>=' },
	{ value: 'lte', label: '<=' },
];

export const OPERATOR_VALUES = OPERATORS.map((o) => o.value);

const NONE_ARITY = new Set(['is_null', 'is_not_null']);
const ARRAY_ARITY = new Set(['in', 'not_in']);

// 'none'   -> the Condition carries NO `value` key at all (is_null / is_not_null)
// 'array'  -> `value` is an array, edited as a tag list (in / not_in)
// 'scalar' -> `value` is a single value (everything else)
export function valueKind(operator) {
	if (NONE_ARITY.has(operator)) return 'none';
	if (ARRAY_ARITY.has(operator)) return 'array';
	return 'scalar';
}

export function operatorLabel(operator) {
	const found = OPERATORS.find((o) => o.value === operator);
	return found ? found.label : operator;
}
